import * as classnames from "classnames";

import { Msg, Icon } from "@shared/components";
import { ApplicantChallengeModel } from "@shared/models";

export type TimeLimitPanelProps = {
  challenge: ApplicantChallengeModel;
  isNew?: boolean;
};

export const TimeLimitPanel = ({
  challenge,
  isNew = false,
}: TimeLimitPanelProps) => {
  const matches = challenge.getTimeLimitLabel().match(/(\d*)(\D+)/);

  const { time = "", timeUnit = "" } =
    Array.isArray(matches) && matches.length === 3
      ? {
          time: matches[1],
          timeUnit: matches[2].trim(),
        }
      : {};

  const rootStyle = classnames({
    ["code-time-limit-panel"]: !isNew,
    ["code-time-limit-panel-new"]: isNew,
  });

  return (
    <div className={rootStyle}>
      <div className="code-time-limit-panel__container">
        <p className="code-time-limit-panel__timetext">
          {!isNew && <Icon type={"clock-o"} />}
          {/* // TTODO: Cleanup when isWebCamEnabled feature flag is removed */}
          <Msg id={"timeLimit"} />
        </p>
        <p>
          {time && <span className="code-time-limit-panel__time">{time}</span>}
          <span className="code-time-limit-panel__time-unit">{timeUnit}</span>
        </p>
      </div>
      <div className="code-time-limit-panel__longtext">
        <Msg
          id={
            // TTODO: Cleanup when isWebCamEnabled feature flag is removed */
            isNew
              ? "start-challenge-walkthrough.startchallenge.warning"
              : "start-challenge.step4.text"
          }
        />
      </div>
    </div>
  );
};
